const Cookie = require('js-cookie');

/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */

$(function () {
    'use strict';

    /**
     * Set cookie so message from cookies will only be displayed once.
     */

    if (Cookie.get('circuloplus_cookies_message_displayed') == undefined) {
        $('#message-cookies').removeClass('hidden');
    }

    $('.cookies-close').click(function (event) {
        event.preventDefault();
        $('#message-cookies').addClass('hidden');
    });

    $('.cookies-accept').click(function (event) {
        event.preventDefault();
        $('#message-cookies').addClass('hidden');
        Cookie.set('circuloplus_cookies_message_displayed', true, { expires: 15 });
    });
});
